<template>
  <label class="file-label">
    <input
      class="file-input"
      type="file"
      :id="inputId"
      :ref="inputRef"
      v-on:change="handleFilesUpload()"
    >
    <span
      class="file-cta"
      :class="{ 'is-danger': hasErrorFile }"
    >
      <span class="file-label">
        {{ fileLabel }}
      </span>
    </span>
    <!-- TODO: figure out width with dynamic breakpoints? -->
    <span
      class="file-name"
      :class="{
        'placeholder': !selectedFiles.length,
        'is-danger': hasErrorFile
      }"
    >
      {{ fileNameDisplay }}
    </span>
  </label>
</template>

<script>
export default {
  props: {
    fileLabel: {
      type: String,
      default: 'Browse',
    },
    hasErrorFile: {
      type: Boolean,
    },
    inputId: {
      type: String,
      required: true,
    },
    inputRef: {
      type: String,
      required: true,
    },
    selectedFiles: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    selectedFiles() {
      if (!this.selectedFiles.length) {
        this.$refs.inputFile.value = '';
      }
    },
  },
  computed: {
    fileNameDisplay() {
      if (this.selectedFiles.length) {
        const validFileExtensions = ['.txt', '.csv'];
        if (validFileExtensions.some(el => this.selectedFiles[0].name.toLowerCase().endsWith(el))) {
          this.$emit('validFileExtensions', true);
        } else {
          this.$emit('validFileExtensions', false);
        }
        return this.selectedFiles[0].name;
      }
      return 'Choose File';
    },
  },
  methods: {
    handleFilesUpload() {
      const uploadedFiles = this.$refs.inputFile.files;
      if (uploadedFiles) this.selectedFiles.length = 0;
      [...uploadedFiles].forEach(file => this.selectedFiles.push(file));
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "~bulma/sass/utilities/_all"
  @import "~bulma/sass/form/file"
  @import "~bulma/sass/form/shared"
  @import "@/sass/custom.sass"

  .file-label
    .file-cta
      &.is-danger
        border-color: red
        border-left: none
    .file-name
      max-width: 100%;
      word-break: break-word;
      overflow-wrap: break-word;
      display: inline-block;
      width: 10px;
      min-width: 0;
      &.is-danger
        border-color: red

  .file-input
    &:hover
      + .file-cta
        background-color: #DDD
        border: 1px solid $input-focus-border-color
    &:active
      + .file-cta
        background-color: #CCC
    &:focus
      + .file-cta
        border: 2px solid $input-focus-border-color
      + .file-name
        border: 2px solid $input-focus-border-color
</style>
